import { MediaSprite } from '../../../types'

export function resizeSprite(sprite: MediaSprite, maxSize: number) {
    if (!maxSize) {
        return sprite
    }

    if (sprite.canvas.width <= maxSize && sprite.canvas.height <= maxSize) {
        return sprite
    }

    const aspectRatio = sprite.canvas.width / sprite.canvas.height
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    canvas.width = maxSize
    canvas.height = Math.round(canvas.width / aspectRatio)

    if (canvas.height > maxSize) {
        canvas.height = maxSize
        canvas.width = Math.round(canvas.height * aspectRatio)
    }

    const scale = canvas.width / sprite.canvas.width

    context?.drawImage(sprite.canvas, 0, 0, canvas.width, canvas.height)

    return {
        ...sprite,
        canvas,
        frameHeight: Math.round(sprite.frameHeight * scale),
        frameWidth: Math.round(sprite.frameWidth * scale),
    }
}
